import React, {Component} from 'react'
import './LiabilityWaiver.Styles.css'
import {appStringEn, appStringVi} from "../../appString"
import {IconContext} from "react-icons"
import {MdHome} from "react-icons/md"

export default class LiabilityWaiverScreen extends Component {
  render() {
    const appString = this.props.location && this.props.location.state && this.props.location.state.isEn ? appStringEn : appStringVi
    return (
      <div className={'liabilityWaiverScreenViewRoot'}>
        <button
          className={'liabilityWaiverScreenBtnGoHome'}
          onClick={() => this.props.history.push({pathname: '/'})}
        >
          <IconContext.Provider value={{color: 'white', size: "30px"}}>
            <MdHome/>
          </IconContext.Provider>
          <span className={'liabilityWaiverScreenTextBtn'}>{appString.goHome}</span>
        </button>
        <div className={'liabilityWaiverScreenViewWrapItem'}>
          <span className={'liabilityWaiverScreenTextTitle'}>{appString.liabilityWaiver.title}</span>
          <span className={'liabilityWaiverScreenTextContent'}>{appString.liabilityWaiver.content}</span>
        </div>
      </div>
    )
  }
}
